/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo, useRef } from 'react';

import { Box } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';
import { metricTypeTransformers } from 'Deer/hooks/dataHooks/metrics/utils/overviewMetricsUtils';
import { DeerBarChart } from 'Deer/pages/Team/DirectReports/DirectReportsOverview/cards/common/DeerBarChart';

import { DISCIPLINARY_ACTIONS_GRAPH_TYPES } from 'constants/ProjectConstants';

type DisciplinaryActionsNotesGraphProps = {
  data: any;
  reportType: string;
  isExpanded: boolean;
};

const DisciplinaryActionsNotesGraph = ({ data, reportType, isExpanded }: DisciplinaryActionsNotesGraphProps) => {
  const ref = useRef();

  const lineChartData = useMemo(() => {
    const transformedData: { [key: string]: unknown } = {};

    data?.forEach((metric: any) => {
      const metricType = metric.metric;
      const dataTransformer = metricTypeTransformers[metricType];
      if (dataTransformer) {
        transformedData[reportType] = dataTransformer(metric);
      }
    });

    return transformedData ? transformedData[reportType] : {};
  }, [reportType, data]);

  return (
    <Box overflow="hidden">
      <Card style={{ height: '100%' }}>
        <CardContent
          style={{
            height: isExpanded ? '70vh' : '240px',
          }}
        >
          <DeerBarChart
            ref={ref}
            nodes={lineChartData?.nodes ?? []}
            xAxisValues={lineChartData?.xAxis ?? []}
            series={lineChartData?.series ?? []}
            xAxisLabel={
              reportType === DISCIPLINARY_ACTIONS_GRAPH_TYPES.DISCIPLINARY_ACTION_NOTES ? 'Time (Monthly)' : 'Stages'
            }
            yAxisLabel="Number of notes"
            tooltipTitle="Progress"
            seriesSelectorTitle="Notes"
            hasNoData={!lineChartData?.series || lineChartData?.series?.length === 0}
            mode="mini"
            customHeight={isExpanded ? '70vh' : '240px'}
            maxNodesInMiniMode={10}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default DisciplinaryActionsNotesGraph;
